<script lang="ts">
    import {
        DEFAULT_LAYOUT,
        LOGO_WIDTH_M,
        LOGO_WIDTH_L,
        ANIMATION_SPEED,
    } from '$lib/components/constants';

    import { cn } from '$lib/utils/cn';

    import LogosList from './LogosList.svelte';
    import { getBoxAttributes } from '../_utils/getBoxAttributes';
    import { getHasAnimation } from '../_utils/getHasAnimation';
    import Box from '../_wrappers/Box.svelte';

    import type { LogoSize } from '$lib/types/Components/Logos/LogosContent';
    import type { Box as BoxType } from '$lib/types/Components/SharedTypes';
    import type { TransitionEffect } from '$lib/types/Theme';

    export let id = '';
    export let box: BoxType;
    export let images: string[] = [];
    export let isGrayscale = false;
    export let size: LogoSize = 'medium';
    export let logoGapXPx: number | undefined = undefined;
    export let paddingClass: string | undefined = undefined;
    export let transitionDelay = 0;
    export let transitionEffect: TransitionEffect = 'default';
    export let layout = DEFAULT_LAYOUT;
    export let isMobile: boolean;

    const isInColumn = layout.isInColumn;

    $: hasAnimation = getHasAnimation(images.length, layout.columnCount, isMobile);
    $: animationDuration = hasAnimation ? images?.length / ANIMATION_SPEED : 0;

    const derivedLogoWidth = size === 'medium' ? LOGO_WIDTH_M : LOGO_WIDTH_L;

    $: slotWidth = derivedLogoWidth + (logoGapXPx ?? 0) * 2;
</script>

<Box {id} {...getBoxAttributes({ box, isInColumn })} {transitionDelay} {transitionEffect}>
    <div
        class={cn('fun-relative fun-w-full fun-overflow-hidden', paddingClass)}
        style:mask-image={hasAnimation
            ? 'linear-gradient(90deg, transparent 5%, rgba(0, 0, 0, 1) 20%, rgba(0, 0, 0, 1) 80%, transparent 95%)'
            : undefined}
    >
        <div
            class={cn('fun-flex fun-items-center fun-justify-center', {
                'fun-animate-logos-slide-loop': hasAnimation,
                'fun-opacity-75': isGrayscale,
            })}
            style:width={hasAnimation
                ? `${
                      images.length * 2 * (logoGapXPx !== undefined ? slotWidth : derivedLogoWidth)
                  }px`
                : undefined}
            style:animation-duration={hasAnimation ? `${animationDuration}s` : undefined}
        >
            <LogosList {images} {isGrayscale} {size} {logoGapXPx} />

            {#if hasAnimation}
                <LogosList {images} {isGrayscale} {size} {logoGapXPx} />
            {/if}
        </div>
    </div>
</Box>
